import "./App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import AdminApp from "./Admin/App";
import Login from "./Admin/Login/Login";
import Home from "./pages/Home";
import React, { useEffect } from 'react';

function App() {

  useEffect(() => {
    document.title = "Whitefriar -  dev";  // Set your title here
  }, []);

  return (
    <div className="App">
      <Routes>
        <Route path="admin-login" element={<Login />} />
      </Routes>
      <Routes>
        <Route path="admin/*" element={<AdminApp />} />
      </Routes>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </div>
  );
}

export default App;
